/**
 * Single source of truth for the side-nav area/tag vocabulary shared across the
 * Python/TS boundary: `navigation_config.py` emits these as `visibleNavTags` and
 * the TS registry filters against them.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SIDE_NAV_VOCABULARY", {
    enumerable: true,
    get: function() {
        return SIDE_NAV_VOCABULARY;
    }
});
const _sidenavvocabularyjson = /*#__PURE__*/ _interop_require_default(require("./side-nav-vocabulary.json"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const SIDE_NAV_VOCABULARY = _sidenavvocabularyjson.default;
